<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">هدف شغل</h4>
    </div>
    <div class="card-body">
      <label class="form-label fw-bold">هدف اصلی شغل</label>
      <textarea
          class="form-control"
          rows="3"
          placeholder="هدف شغل را توضیح دهید"
          v-model="jobDescription.job_purpose"
      ></textarea>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    jobDescription: {
      get() {
        return this.$store.state.jobDescription.jobDescription;
      }
    },
  },
}
</script>